import { History, MoreHorizontal, Plus } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

export interface ClientContractEntry {
  id: string;
  typeLabel: string;
  clientName: string;
  clientDocument: string;
  version: string;
  statusLabel: string;
  active: boolean;
}

interface ClientContractTableProps {
  entries: ClientContractEntry[];
  onEdit?: (entry: ClientContractEntry) => void;
  onToggleActive?: (entry: ClientContractEntry) => void;
  onHistory?: (entry: ClientContractEntry) => void;
  onPublishVersion?: (entry: ClientContractEntry) => void;
}

export function ClientContractTable({
  entries,
  onEdit,
  onToggleActive,
  onHistory,
  onPublishVersion,
}: ClientContractTableProps) {
  return (
    <div className="overflow-x-auto rounded-md border bg-white">
      <Table className="min-w-[820px]">
        <TableHeader>
          <TableRow>
            <TableHead>Tipo</TableHead>
            <TableHead>Cliente</TableHead>
            <TableHead>CNPJ</TableHead>
            <TableHead className="w-[110px]">Versão</TableHead>
            <TableHead className="w-[140px]">Status</TableHead>
            <TableHead className="w-[80px] text-right">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {entries.map((entry) => (
            <TableRow key={entry.id}>
              <TableCell className="font-medium">{entry.typeLabel}</TableCell>
              <TableCell>{entry.clientName}</TableCell>
              <TableCell className="tabular-nums">{entry.clientDocument}</TableCell>
              <TableCell className="tabular-nums">{entry.version}</TableCell>
              <TableCell>
                <Badge variant="secondary-subtle">{entry.statusLabel}</Badge>
              </TableCell>
              <TableCell className="text-right">
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
                      <MoreHorizontal className="h-4 w-4" />
                      <span className="sr-only">Abrir ações do contrato de {entry.clientName}</span>
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem disabled={!onEdit} onSelect={() => onEdit?.(entry)}>
                      Editar
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      disabled={!onToggleActive}
                      onSelect={() => onToggleActive?.(entry)}
                    >
                      {entry.active ? 'Inativar' : 'Ativar'}
                    </DropdownMenuItem>
                    <DropdownMenuItem disabled={!onHistory} onSelect={() => onHistory?.(entry)}>
                      <History className="mr-2 h-4 w-4" />
                      Histórico
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      disabled={!onPublishVersion}
                      onSelect={() => onPublishVersion?.(entry)}
                    >
                      <Plus className="mr-2 h-4 w-4" />
                      Criar nova versão
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
